const state = {
  staticTexts: [],
};

const mutations = {
  setSystemStatic(state, staticData) {
    state.staticTexts = staticData;
  },
};

const actions = {
  setSystemStatic({ commit }, staticData) {
    commit("setSystemStatic", staticData);
  },
};

const getters = {
  systemStaticTexts: (state) => {
    return state.staticTexts;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
